import { Role } from '@/enums/role';
import type {
  BulkPriceRow,
  BulkPriceTarget
} from '@/types/BulkPrice.interface';

interface TargetContext {
  role: Role | string | undefined;
  isAdminView: boolean;
  hasBranch: boolean;
  /** Company settings allow branch prices (not CENTRALIZED, overrides on). */
  overridesEnabled: boolean;
}

/**
 * Which prices the user may change in bulk, the default first: the
 * products' own price for super and company admins, the selected branch's
 * price in branch view (first there). Branch admins only change their
 * branch's price.
 */
export function bulkPriceTargets({
  role,
  isAdminView,
  hasBranch,
  overridesEnabled
}: TargetContext): BulkPriceTarget[] {
  const branch = hasBranch && !isAdminView && overridesEnabled;
  if (role === Role.SUPER_ADMIN || role === Role.COMPANY_ADMIN) {
    return branch ? ['BRANCH', 'BASE'] : ['BASE'];
  }
  if (role === Role.BRANCH_ADMIN) {
    return branch ? ['BRANCH'] : [];
  }
  return [];
}

/** New minus old price, in lira with kuruş precision. */
export function priceDelta(row: BulkPriceRow): number {
  return Math.round((row.newPrice - row.oldPrice) * 100) / 100;
}

/** Rows whose price actually changes. */
export function changedRows(rows: BulkPriceRow[]): BulkPriceRow[] {
  return rows.filter((row) => priceDelta(row) !== 0);
}
